<template>
  <div class="containerRow">
    <div class="boxsize">
      <div class="box-header">
        <div class="title-container" v-if="vehicle">
          <H3>{{ vehicle.targa }}</H3>
          <H4> {{ vehicle.marca }} - {{ vehicle.modello }} </H4>
        </div>
        <div class="info-container">
          <div class="logoandtext small">
            <div class="btnr-container-container">
              <span class="button is-info is-tiny" @click="doCruscottoClear()"
                >chiudi</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="logoandtext large">
        <div class="img-container"><img src="images/datatime.png" /></div>
        <div class="text-container" v-if="lastPos">
          {{ reverseDate(lastPos.date) }}
        </div>
      </div>
      <div class="logoandtext large">
        <div class="img-container"><img src="images/placeholder.png" /></div>
        <div class="text-container" v-if="lastPos">
          {{ lastPos.address | pipe_filter }}
        </div>
      </div>

      <div class="logoandtext large">
        <div class="img-container"><img src="images/direction.png" /></div>
        <div class="text-container" v-if="lastPos">
          {{ resolveMovimento() }} - Km/h {{ lastPos.speed }}
        </div>
      </div>
    </div>
    <div class="graphDiv">
      <template
        v-if="
          dataCards &&
          lastDataStory &&
          shortHistory === null &&
          report1 !== null
        "
      >
        <div class="graphs">
          <TimetableCard
            :card_no="0"
            :report="report1"
            :lastDataStory="lastDataStory"
            :dataCards="dataCards"
            :driver_name="getDriverName(0)"
          />
          <TimeLine :options="optGraph" :data="card1_timeline" />
        </div>
        <div class="graphs" v-if="dataCards.slots2[0].icard !== 'EMPTY'">
          <TimetableCard
            :card_no="1"
            :report="report2"
            :lastDataStory="lastDataStory"
            :dataCards="dataCards"
            :driver_name="getDriverName(1)"
          />
          <TimeLine :options="optGraph" :data="card2_timeline" />
        </div>
      </template>
      <template v-if="shortHistory">
        <div>
          <div
            class="logoandtext large"
            v-if="!dataCards && vehicle.autista.length > 0"
          >
            <div class="img-container">
              <img src="images/delivery-man.png" />
            </div>
            <div class="text-container" v-if="vehicle">
              {{ vehicle.autista }}
            </div>
          </div>
          <div class="graphs_history" v-if="shortHistory.length > 0">
            <TimetableCardHistory :report="reportHistory" />
            <TimeLineHistory :data="shortHistory" />
          </div>
          <div v-else class="title-container pt-5">
            <H3>Nessuna attività in data odierna</H3>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../../ServiceBus.js'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
import TimetableCard from './TimetableCard.vue'
import TimetableCardHistory from './TimetableCardHistory.vue'
import TimeLine from './TimeLine.vue'
import TimeLineHistory from './TimeLineHistory.vue'

export default {
  name: 'Cruscotto',
  components: {
    TimeLine,
    TimeLineHistory,
    TimetableCard,
    TimetableCardHistory,
  },
  mixins: [UtilityMixin],
  props: {
    dataCards: {
      default: null,
      type: Object,
    },
    lastDataStory: {
      default: null,
      type: Object,
    },
    lastPos: {
      default: null,
      type: Object,
    },
    vehicle: {
      default: null,
      type: Object,
    },
    drivers: {
      default: null,
      type: Array,
    },
    start: {
      default: null,
      type: Date,
    },
    end: {
      default: null,
      type: Date,
    },
  },
  data() {
    return {
      status: ['FERMO', 'IN MOVIMENTO'],
      stateImg: ['riposo.png', 'disp.png', 'lavoro.png', 'guida.png'],
      optGraph: { height: 15, width: 900 },
      card1_timeline: null,
      card2_timeline: null,
      report1: null,
      report2: null,
      shortHistory: null,
      reportHistory: null,
      isShortReport: false,
    }
  },
  mounted() {
    const vm = this
    console.log('vm.dataCards', vm.dataCards)
    vm.doAnalize()
    // if (vm.dataCards !== null) {
    //   vm.shortHistory = null
    //   vm.doActivityDriver()
    // } else {
    //   vm.card1_timeline = null
    //   vm.card2_timeline = null
    //   vm.report1 = null
    //   vm.report2 = null
    //   vm.doShortHistory()
    // }
  },
  methods: {
    async doAnalize() {
      const vm = this
      if (vm.dataCards !== null) {
        vm.shortHistory = null
        console.log('pass 0')
        await vm.doActivityDriver()
      }

      if (vm.dataCards === null || vm.checkNullActivityDriver()) {
        vm.card1_timeline = null
        vm.card2_timeline = null
        vm.report1 = null
        vm.report2 = null
        await vm.doShortHistory()
      }
    },

    checkNullActivityDriver() {
      const vm = this
      let f1 = true
      let f2 = true

      if (vm.report1 !== null) {
        f1 = vm.report1.guida.length < 1 && vm.report1.disp.length < 1
      }
      if (vm.report2 !== null) {
        f2 = vm.report2.guida.length < 1 && vm.report2.disp.length < 1
      }
      return f1 && f2
    },

    doCruscottoClear() {
      ServiceBus.$emit('cruscottoClear')
    },

    async doShortHistory() {
      const vm = this
      let km_start = 0
      let start_ = new Date(vm.end)
      let end_ = new Date(vm.end)
      start_.setHours(0)
      start_.setMinutes(0)
      start_.setSeconds(0)
      const history = await ServiceBus._doGetPosCalcBIS(
        vm.vehicle.cod,
        start_,
        end_
      )
      const summa = function (acc, obj) {
        return acc + obj.min
      }
      const summa_km = function (acc, obj) {
        return acc + (obj.km ?? 0)
      }
      const calcMin = (start_date, end_date) => {
        if (start_date && end_date) {
          return (end_date.getTime() - start_date.getTime()) / 1000 / 60
        }
        return 0
      }
      const createElement = (start_date, end_date, mode_, counter) => {
        let item = {}
        item.from = new Date(start_date)
        item.to = new Date(end_date)
        item.min = calcMin(item.from, item.to)
        item.v = mode_
        if (counter) {
          item.km = counter.km
          item.min_guida = counter.min_guida
        }

        return item
      }
      const getMode = (message) => {
        if (message.indexOf('START') >= 0) {
          return 1
        }
        if (message.indexOf('STOP') >= 0) {
          if (message.indexOf('COUNTER') >= 0) {
            return -1
          } else {
            return 0
          }
        }
        return -1
      }
      const getCounter = (message) => {
        if (message.indexOf('COUNTER') >= 0) {
          let counter = null
          let arry = message.split(' ')
          if (arry.length > 2) {
            counter = {}
            counter.km = parseInt(arry[1].split(':')[1])
            counter.min_guida = parseInt(arry[2].split(':')[1])
            return counter
          }
          return null
        }
        if (message.indexOf('Trip Start') >= 0) {
          let counter = null
          let arry = message.split(':')
          if (arry.length > 1) {
            km_start = parseInt(arry[1])

            return null
          }
        }
        if (message.indexOf('Trip End') >= 0) {
          let counter = null
          let arry = message.split(':')
          if (arry.length > 1) {
            counter = {}
            counter.km = Math.trunc((parseInt(arry[1]) - km_start) / 10)

            counter.min_guida = 0
            return counter
          }
          return null
        }
      }

      let counter = null
      let mode
      let curr_item = null
      let items = []
      let temp_counter

      for (let i = 0; i < history.length; i++) {
        mode = getMode(history[i].message)
        temp_counter = getCounter(history[i].message)
        if (temp_counter) {
          counter = temp_counter
        }
        if (mode >= 0) {
          if (curr_item === null) {
            if (mode === 1) {
              curr_item = createElement(start_, history[i].date, 0, null)
              items.push(curr_item)
              curr_item = createElement(history[i].date, null, 1, null)
            } else {
              curr_item = createElement(start_, history[i].date, 1, counter)
              items.push(curr_item)
              curr_item = createElement(history[i].date, null, 0, null)
              counter = null
            }
          } else {
            if (mode !== curr_item.v) {
              curr_item.to = new Date(history[i].date)
              curr_item.min = calcMin(curr_item.from, curr_item.to)
              if (counter) {
                curr_item.km = counter.km
                curr_item.min_guida = counter.min_guida
                counter = null
              }
              items.push(curr_item)
              curr_item = createElement(history[i].date, null, mode, null)
            }
          }
        }
      }
      if (curr_item) {
        curr_item.to = new Date(end_)
        curr_item.min = calcMin(curr_item.from, curr_item.to, null)
        if (counter) {
          curr_item.km = counter.km
          curr_item.min_guida = counter.min_guida
          counter = null
        }
        items.push(curr_item)
      }
      for (let i = 0; i < items.length; i++) {
        items[i].id = 'A' + i
      }
      vm.shortHistory = items
      if (vm.shortHistory.length > 0) {
        const fermo = vm.shortHistory.filter((item) => item.v === 0)
        const corsa = vm.shortHistory.filter((item) => item.v === 1)
        vm.reportHistory = {}
        vm.reportHistory.sosta = fermo.reduce(summa, 0)
        vm.reportHistory.guida_min = corsa.reduce(summa, 0)
        vm.reportHistory.guida_km = corsa.reduce(summa_km, 0)
        ServiceBus.$emit('setMax')
      } else {
        ServiceBus.$emit('setShort')
      }
    },

    async doActivityDriver() {
      console.log('PASS 1')
      const vm = this
      if (
        vm.dataCards.length === 0 ||
        vm.dataCards.slots1[0].icard === 'EMPTY'
      ) {
        vm.card1_timeline = null
        vm.report1 = null
      } else {
        console.log('PASS 2')
        vm.card1_timeline = await ServiceBus._doGetActivityDriver(
          vm.dataCards.slots1[0].icard,
          vm.start,
          vm.end
        )
        console.log('DBG vm.card1_timeline', vm.card1_timeline)
        vm.report1 = await ServiceBus._doCreateReport(
          vm.dataCards.slots1[0].icard,
          vm.start,
          vm.end,
          vm.card1_timeline
        )
        console.log('DBG vm.report1', vm.report1)
      }
      if (
        vm.dataCards.length === 0 ||
        vm.dataCards.slots2[0].icard === 'EMPTY'
      ) {
        vm.card2_timeline = null
        vm.report2 = null
      } else {
        vm.card2_timeline = await ServiceBus._doGetActivityDriver(
          vm.dataCards.slots2[0].icard,
          vm.start,
          vm.end
        )
        console.log('DBG vm.card2_timeline', vm.card2_timeline)
        vm.report2 = await ServiceBus._doCreateReport(
          vm.dataCards.slots2[0].icard,
          vm.start,
          vm.end,
          vm.card2_timeline
        )
        console.log('DBG vm.report2', vm.report2)
      }
      ServiceBus.$emit('shortMax')
    },

    getDriverName(card_no) {
      const vm = this
      let icard = ''
      if (vm.dataCards) {
        if (card_no === 0) {
          if (vm.dataCards.slots1.length > 0) {
            icard = vm.dataCards.slots1[0].icard
          }
        } else {
          if (vm.dataCards.slots2.length > 0) {
            icard = vm.dataCards.slots1[0].icard
          }
        }
      }
      if (icard.length > 0) {
        let obj = vm.findDriver(icard)
        if (obj) {
          return obj.autista
        }
      }
      return '-'
    },

    findDriver(icard) {
      const vm = this
      let finder = function (obj) {
        return obj.cod_f.includes(icard)
      }
      return vm.drivers.find(finder)
    },
    resolveMovimento() {
      const vm = this
      let result = '-'
      if (vm.dataStory) {
        if (vm.dataStory.analogs) {
          result = vm.status[vm.data.analogs.values[0]]
        }
      } else {
        result =
          vm.lastPos.speed > 0
            ? (result = vm.status[1])
            : (result = vm.status[0])
      }
      return result
    },
  },
}
</script>
<style scoped>
.title-container h3,
.title-container h4 {
  font-weight: bold;
}
.title-container {
  padding-left: 10px;
}
.logoandtext {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
  padding-top: 5px;
  padding-bottom: 5px;
}
.logoandtext .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 48px;
}

.logoandtext .img-container img {
  max-height: 24px;
}

.logoandtext .text-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
}

.logoandtext .btnr-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 2;
}

.box-header {
  display: flex;
  padding-bottom: 10px;
}

.box-header .title-container {
  flex: 1;
}

.boxsize {
  width: 400px;
}

.small {
  font-size: 9px;
}

.medium {
  font-size: 12px;
}

.large {
  font-size: 14px;
}

.subinfo {
  padding-left: 47px;
}
.bold {
  font-weight: bold;
}

.lineclick {
  cursor: pointer;
}

.graphs_history {
  margin: 5px;
  margin-top: 20px;
  border-style: solid;
  border-width: 1px;
}

.graphs {
  margin: 5px;
  border-style: solid;
  border-width: 1px;
}

.containerRow {
  display: flex;
  flex-direction: row;
  border: 1px solid lightgray;
}
.containerVis {
  width: 16px;
  height: 16px;
}

/* Resize images */
.containerVis img {
  width: 100%;
  height: auto;
}

.graphDiv {
  flex: 1;
}
</style>
